import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getAdditionalFurnitureMasterListUrl, insertUpdateAdditionalFurnitureMasterUrl, deleteAdditionalFurnitureMasterUrl,getFurnitureShellSchemeUrl,deleteInsertShellSchemeUrl, GET_ADDITIONAL_FURNITURE_MASTER_LIST, INSERT_UPDATE_ADDITIONAL_FURNITURE_MASTER, DELETE_ADDITIONAL_FURNITURE_MASTER,GET_FURNITURE_SHELL_SCHEME_LIST,DELETE_INSERT_SHEEL_SCHEME } from "../../../../utils/constants";


export const insertUpdateAdditionalFurnitureMaster_action = (AdditionalFurnituremasterList, AdditionalFurnitureBankDetailList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            AdditionalFurnituremasterList: AdditionalFurnituremasterList
        }
        console.log("insertUpdateAdditionalFurnitureMaster_action Action------->", params)

        const res = await axiosPost(insertUpdateAdditionalFurnitureMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_ADDITIONAL_FURNITURE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteInsertShellScheme_action = (ConfigFurnitureDetailList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ConfigFurnitureDetailList: ConfigFurnitureDetailList
        }
        console.log("deleteInsertShellScheme_action Action------->", params)

        const res = await axiosPost(deleteInsertShellSchemeUrl, params, headers)

        dispatch({
            type: DELETE_INSERT_SHEEL_SCHEME,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAdditionalFurnitureMasterList_action = (Items,Status) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            Items:Items,
            Status:Status
        }
        console.log("getAdditionalFurnitureMasterList_action Action------->", params)

        const res = await axiosGet(getAdditionalFurnitureMasterListUrl, params, headers)

        dispatch({
            type: GET_ADDITIONAL_FURNITURE_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getShellSchemeList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getAdditionalFurnitureMasterList_action Action------->", params)

        const res = await axiosGet(getFurnitureShellSchemeUrl, params, headers)

        dispatch({
            type: GET_FURNITURE_SHELL_SCHEME_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteAdditionalFurnitureMaster_action = (MstAdditionalFurnitureID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            MstAdditionalFurnitureID: MstAdditionalFurnitureID
        }
        console.log("deleteAdditionalFurnitureMaster_action Action------->", params)

        const res = await axiosGet(deleteAdditionalFurnitureMasterUrl, params, headers)

        dispatch({
            type: DELETE_ADDITIONAL_FURNITURE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}